import { useQuery } from '@tanstack/react-query';
import { IMyPokeTractor } from '../../../../interfaces/OwnTractor.interfaces';
import { AxiosError } from 'axios';
import { getMyPokeTractors } from '../../../../api/user/queries/getMyPokeTractors';
import { useCheckUserLoggedIn } from '../../../user/useCheckUserLoggedIn';

export const MY_POKE_TRACTORS_QUERY_KEY = ['my-poke-tractors'] as const;

export const useGetMyPokeTractors = () => {
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  return useQuery<IMyPokeTractor[], AxiosError>(MY_POKE_TRACTORS_QUERY_KEY, getMyPokeTractors, {
    enabled: isUserLoggedIn,
  });
};
